import { render, staticRenderFns } from "./LawyerInvoice.vue?vue&type=template&id=7feea551&scoped=true&"
import script from "./LawyerInvoice.vue?vue&type=script&lang=js&"
export * from "./LawyerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./LawyerInvoice.vue?vue&type=style&index=0&id=7feea551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feea551",
  null
  
)

/* custom blocks */
import block0 from "./LawyerInvoice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon,VRow})
